import { createAction, createSlice } from '@reduxjs/toolkit';
import initState from '../../../domain/entities/encuesta';

function encuestaCorrecta(state, action) {
  const { responseEncuesta } = action.payload;
  state.response = responseEncuesta;
  state.responseError = false;
}

function encuestaError(state, action) {
  const { responseEncuesta } = action.payload;
  state.response = responseEncuesta;
  state.responseError = true;
}

const encuesta = createAction('encuesta');

const encuestaReducer = createSlice({
  name: 'encuesta',
  initialState: initState,
  reducers: {
    encuestaCorrecta,
    encuestaError
  },
});

export const encuestaActions = {
  ...encuestaReducer.actions,
  encuesta,
};

export default encuestaReducer.reducer;
